<div class="fullscreen-overlay">
  <button class="close-btn" mat-icon-button (click)="close()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
  <button class="nav-btn left" mat-icon-button (click)="prev()" [disabled]="currentIndex === 0">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <img [src]="currentImageUrl" class="fullscreen-img" alt="Image" />
  <button class="nav-btn right" mat-icon-button (click)="next()" [disabled]="currentIndex === data.images.length - 1">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
